/**
 * Consent constants and audit-record generation. Kept apart from cookie-services.ts (the large,
 * translated cookie inventory) so the consent manager and analytics can load without the inventory;
 * only the cookie banner needs that.
 */

export const CONSENT_CONFIG = {
  COOKIE_NAME: 'm2b-cookie-consent',
  VERSION: '4.0',
  EXPIRATION_DAYS: 180, // 6 months per GDPR best practice
  AUDIT_RETENTION_DAYS: 1095, // 3 years for legal audit trail (Art. 7 Abs. 1 GDPR)
  RENEWAL_THRESHOLD_DAYS: 30, // Renew consent if expires within 30 days
  FORCED_RENEWAL_ON_VERSION_CHANGE: true,
  GRANULAR_CONSENT_REQUIRED: true, // No "accept all" pre-selection
  CONSENT_MODE: 'opt-in', // Explicit opt-in required
  PRIVACY_BY_DESIGN: true,
  AUTOMATIC_COOKIE_DELETION: true, // Delete cookies when consent withdrawn
  AUDIT_LOG_ENABLED: true,
  ANONYMIZED_LOGGING: true,
}

export function generateConsentAuditData() {
  const consentId = `consent_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`

  // GDPR-compliant audit data (Art. 7 Abs. 1 GDPR - no personal identifiers stored)
  return {
    consentId,
    timestamp: new Date().toISOString(),
    version: CONSENT_CONFIG.VERSION,
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent.substring(0, 100) : null, // Truncated for privacy
    referrer: typeof document !== 'undefined' ? document.referrer : null,
    consentMethod: 'explicit', // vs 'inferred' - always explicit per GDPR
    // Note: No IP addresses, fingerprints, or other identifying data stored per data minimization
    gdprCompliant: true,
    ttdsgCompliant: true,
  }
}
